import { useState, useEffect, useMemo } from 'react';
import './Waterways.css';
import Waterways from './Waterways';
import 'react-toastify/dist/ReactToastify.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

const WaterwaysMap = ({ refreshToken,handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const [waterways, setWaterways] = useState({
        Section: 'WaterwaysMap', SectionName: 'Waterways', IsMapOnly: true, IsMapRisk : false
    });
    useEffect(() => {
         OnPageload();
    }, [])
    const OnPageload = async (e) => {

    }
    return (
        <div>
            <Waterways refreshToken={refreshToken} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} handleMoveToNextPage={handleMoveToNextPage} pageSection={waterways} ></Waterways>
        </div>
    )
}
export default WaterwaysMap;